import React from 'react'
import { PageBodyNavigation } from '../PageLayout/PageLayout'
import { PageFooterTemplate } from '../PageTemplate/PageFooterTemplate'
import { PageHeaderTemplate } from '../PageTemplate/PageHeaderTemplate'
import { PageTemplate } from '../PageTemplate/PageTemplate'
import type {
  SettingsPageFooterTemplateProps,
  SettingsPageHeaderTemplateProps,
  SettingsPageTemplateProps,
} from './SettingsPageTemplate.types'

export const SettingsPageHeaderTemplate = React.forwardRef<
  HTMLDivElement,
  SettingsPageHeaderTemplateProps
>((props, ref) => {
  return (
    <PageHeaderTemplate
      ref={ref}
      {...props}
      data-core-react="settings-page-header-template"
    />
  )
})

export const SettingsPageFooterTemplate = React.forwardRef<
  HTMLDivElement,
  SettingsPageFooterTemplateProps
>((props, ref) => {
  return (
    <PageFooterTemplate
      ref={ref}
      {...props}
      data-core-react="settings-page-footer-template"
    />
  )
})

export const SettingsPageTemplate = React.forwardRef<
  HTMLDivElement,
  SettingsPageTemplateProps
>(
  (
    {
      children,
      footer,
      footerProps,
      hasNavigation,
      header,
      headerProps,
    }: SettingsPageTemplateProps,
    ref
  ) => {
    return (
      <PageTemplate
        data-core-react="settings-page-template"
        header={header ?? <SettingsPageHeaderTemplate {...headerProps!} />}
        footer={
          footer ?? (
            <SettingsPageFooterTemplate
              {...footerProps}
              actions={footerProps?.actions!}
            />
          )
        }
        innerPane={hasNavigation && <PageBodyNavigation minSections={3} />}
        ref={ref}
      >
        {children}
      </PageTemplate>
    )
  }
)
